import { createSlice } from "@reduxjs/toolkit";

export const saleProductSlice = createSlice({
    name: "saleProduct",
    initialState: {
        saleProducts: [],
        saleProductsCopy: [],
        saleProductDetail: {}
    },
    reducers: {
        getSaleProductsReducer: (state, action) => {
            state.saleProducts = action.payload;
            state.saleProductsCopy = action.payload;
        },
        getSaleProductByIdReducer: (state, action) => {
            const productId = action.payload;
            state.saleProductDetail = state.saleProducts.find(saleProduct => saleProduct.id === productId);
        },
        filterByBrandReducer: (state, action) => {
            const productsByBrands = state.saleProducts.filter(
                saleProduct => saleProduct.brand === action.payload
            )
            state.saleProductsCopy = action.payload === 'allBrands' ? [...state.saleProducts] : productsByBrands
        },
        filterByCategoryReducer: (state, action) => {
            const producstByCategory = state.saleProducts.filter(
                saleProduct => saleProduct.category === action.payload
            )
            state.saleProductsCopy = action.payload === 'allCategories' ? [...state.saleProducts] : producstByCategory
        },
        orderByPriceReducer: (state, action) => {
            const saleProductsOrderPrice = [...state.saleProductsCopy];
            
            const compareAscending = (a, b) => a.price - b.price;
        
            const compareDescending = (a, b) => b.price - a.price;
        
            saleProductsOrderPrice.sort(action.payload === 'A' ? compareAscending : compareDescending);
        
            state.saleProductsCopy = saleProductsOrderPrice;
        },
    }
});

export const { getSaleProductsReducer, getSaleProductByIdReducer, filterByBrandReducer, filterByCategoryReducer, orderByPriceReducer } = saleProductSlice.actions;

export default saleProductSlice.reducer;